import { Suspense, lazy, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { LazyMotion, domAnimation, AnimatePresence, m } from "framer-motion";
import ReactGA from 'react-ga4';
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import Home from "./pages/Home";

const Companies = lazy(() => import("./pages/Companies"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));


const fade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.25 },
};

// Initialize GA4 once, outside the component to avoid re-initializing
if (process.env.REACT_APP_GA_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
}

export default function App() {
  const location = useLocation();

  // Hide Nav on Home
  const isHome = location.pathname === "/";

  // Track page views when URL changes
  useEffect(() => {
     if (process.env.REACT_APP_GA_ID) {
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
     }
  }, [location]);

  return (
    <LazyMotion features={domAnimation} strict>
      <div className="max-w-5xl mx-auto p-6 min-h-screen flex flex-col">
        {!isHome && (
          <m.div
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
          >
            <Nav />
          </m.div>
        )}

        <main className="flex-1">
          <AnimatePresence mode="wait">
            <m.div key={location.pathname} {...fade}>
              <Suspense fallback={null}>
                <Routes location={location}>
                  <Route path="/" element={<Home />} />
                  <Route path="/companies" element={<Companies />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </m.div>
          </AnimatePresence>
        </main>

        {!isHome && <Footer />}
      </div>
    </LazyMotion>
  );
}
